import { CmsObjectWithDefault } from '@components/Cms/types';

// Todo: Fix naming convention of each key, either follow camelCase or PascalCase
export type EmailLoginFormViewCmsKey =
    | 'emailLabel'
    | 'passwordLabel'
    | 'emailSignInButton'
    | 'BySigningIn_IAgreeToAgoda'
    | 'TermsOfUse'
    | 'PrivacyPolicy'
    | 'ForgotPassword'
    | 'createAccount'
    | 'emailLabelRurubu'
    | 'passwordLabelRurubu'
    | 'continueWithoutSignIn'
    | 'keepMeSignedIn'
    | 'signInWithOtp';

export const EmailLoginFormViewCmsWithDefault: CmsObjectWithDefault<EmailLoginFormViewCmsKey> = {
    emailLabel: {
        cmsId: 67374,
        defaultTranslation: 'Email',
    },
    emailLabelRurubu: {
        cmsId: 98494,
        defaultTranslation: '会員ID',
    },
    passwordLabel: {
        cmsId: 67375,
        defaultTranslation: 'Password',
    },
    passwordLabelRurubu: {
        cmsId: 98496,
        defaultTranslation: 'パスワード（半角英数字)',
    },
    emailSignInButton: {
        cmsId: 67377,
        defaultTranslation: 'Sign in',
    },
    BySigningIn_IAgreeToAgoda: {
        cmsId: 73926,
        defaultTranslation: "By signing in, I agree to Agoda's {0} and {1}.",
    },
    TermsOfUse: {
        cmsId: 73927,
        defaultTranslation: 'Terms of Use',
    },
    PrivacyPolicy: {
        cmsId: 73928,
        defaultTranslation: 'Privacy Policy',
    },
    ForgotPassword: {
        cmsId: 59489,
        defaultTranslation: 'Forgot password',
    },
    createAccount: {
        cmsId: 101957,
        defaultTranslation: 'Create account',
    },
    continueWithoutSignIn: {
        cmsId: 108525,
        defaultTranslation: 'Continue without signing in',
    },
    keepMeSignedIn: {
        cmsId: 98627,
        defaultTranslation: 'Keep me signed in',
    },
    signInWithOtp: {
        cmsId: 331881,
        defaultTranslation: 'Sign in with OTP',
    },
};
